import { defineStore } from 'pinia';
import { useBookingStore } from './bookingStore';
import { useAmendBookingStore } from './amendBookingStore';
import { useModuleStore } from './moduleStore';
import { useAuthUserStore } from './authUserStore';
import { useMainStore } from './mainStore';
import { formRules } from '../assets/js/formRules.js';
import { useEquipesStore } from './equipesStore';
import { useGroupeStore } from './groupeStore';



export const useBookingSystemStore = defineStore('bookingSystem', {
    state: () => ({
        booking: useBookingStore(),
        amendBooking: useAmendBookingStore(),
        preselection: null,
        groupe: useGroupeStore(),
        equipes: useEquipesStore(),
    }),
    actions: {
        init() {
            const moduleStore = useModuleStore();
            const authUserStore = useAuthUserStore();
            const id_module = parseInt(moduleStore.id);
            const exclude_taxe = moduleStore.has_exclude_taxe;
            const id_account = authUserStore.isLogged ? parseInt(authUserStore.userData.id) : 0;

            // If the booking id_module is not set or is different from the current module id, reset the booking.
            if (this.booking.id_module && this.booking.id_module != id_module) {
                this.booking.clearState();
            }
            this.booking.init(id_module, exclude_taxe, id_account, this.groupe.is_inscription_groupe);
            this.booking.init_inscriptions(this.preselection);


        },



        init_from_dossard_bourse(dossard_bourse) {

            const moduleStore = useModuleStore();
            const authUserStore = useAuthUserStore();
            const id_module = parseInt(moduleStore.id);
            const exclude_taxe = moduleStore.has_exclude_taxe;
            const id_account = authUserStore.isLogged ? parseInt(authUserStore.userData.id) : 0;

            // If the booking id_module is not set or is different from the current module id, reset the booking.
            if (this.booking.id_module && this.booking.id_module != id_module) {
                this.booking.clearState();
            }
            this.booking.init(id_module, exclude_taxe, id_account, this.groupe.is_inscription_groupe);
            this.booking.init_from_dossard_bourse(dossard_bourse);
        },

        clearPreselectionOnSoloCourse() {
            const course_type = this.preselection?.course?.type;
            if (!course_type) {
                this.preselection = null;
                return;
            }
            const equipe_types = ["duo", "equipe", "relais"];
            if (!equipe_types.includes(course_type)) {
                this.preselection = null;
            }
        },

    },
    getters: {
        some_inscriptions_open() {
            let opened = this.booking.inscriptions.filter((inscription) => inscription.finished == false);
            return opened.length > 0;
        },
        limit_inscription_vip_reached() {
            const mainStore = useMainStore();
            if (!mainStore.inscription_vip) return false;
            return this.booking.inscriptions.length >= mainStore.inscription_vip.nb_inscrits;
        },

        has_unique_equipes_names() {
            if (!this.equipes) return true;
            for (let i = 0; i < this.equipes.length; i++) {
                let equipe_name = this.equipes[i].nom;
                if (equipe_name == "" || !equipe_name) return false;
                if (formRules.equipe(equipe_name, i, this.equipes) != true) return false;
            }
            return true;
        }

    },
});